package io.github.jpuf.portfolio.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import io.github.jpuf.portfolio.CircleButtonVariant
import io.github.jpuf.portfolio.CorneredButtonVariant
import io.github.jpuf.portfolio.UncoloredButtonVariant
import org.jetbrains.compose.web.css.em

@Composable
fun IconButton(modifier: Modifier = Modifier, onClick: () -> Unit, isCircle: Boolean = false, content: @Composable () -> Unit) {
    val variant = if (isCircle) CircleButtonVariant else CorneredButtonVariant
    Button(
        onClick = { onClick() },
        modifier.setVariable(ButtonVars.FontSize, 1.em),
        variant = variant.then(UncoloredButtonVariant),
    ) {
        content()
    }
}
